<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- GO BACK BUTTON -->
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="goBack()"></button>
        <button pButton pRipple label="{{translations.lbl_new_record}}" icon="pi pi-plus"
            class="p-button-success p-mr-2" (click)="openNew()" *ngIf="this.showInternatColumns"></button>
    </ng-template>
</p-toolbar>

<!-- MAIN SCREEN -->
<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_item}}:</span>
                    <span class="p-text-bold">{{itemId}} - {{item!=null && item.descrip!=null?item.descrip:""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_collection}}:</span>
                    <span class="p-text-bold">{{albumId}} - {{itemsAlbum!=null &&
                        itemsAlbum.descrip!=null?itemsAlbum.descrip:""}}</span>
                </div>
            </p-panel>
        </div>
    </div>

    <p-table #dt [value]="lstItemsTrak" [globalFilterFields]="['descrip']" [rowHover]="true" dataKey="id"
        styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">

            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0"> {{translations.lbl_manuals_tutorials}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th style="width:5rem" pSortableColumn="sequence">{{translations.lbl_id}}<p-sortIcon field="sequence">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="descrip">{{translations.lbl_name}}<p-sortIcon field="descrip">
                    </p-sortIcon>
                </th>
                <th *ngIf="globalUserPreferences.preferences.levelId=='I'" pSortableColumn="link">
                    {{translations.lbl_link}}<p-sortIcon field="link">
                    </p-sortIcon>
                </th>
                <th style="width:4rem" pSortableColumn="status" *ngIf="this.showInternatColumns">
                    {{translations.lbl_status}}<p-sortIcon field="status">
                    </p-sortIcon>


                <th style="width:4rem" *ngIf="this.showInternatColumns"> {{translations.lbl_edit}}</th>
                <th style="width:5rem">{{translations.lbl_link}}</th>
                <th style="width:5rem" *ngIf="this.showInternatColumns">{{translations.lbl_approve}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.id.seqDt2}}</td>
                <td>{{value.descrip}}</td>
                <td *ngIf="globalUserPreferences.preferences.levelId=='I'">{{value.link}}</td>

                <td *ngIf="this.showInternatColumns">{{value.status}}</td>


                <td *ngIf="this.showInternatColumns">
                    <button type="button" pButton pRipple icon="pi pi-pencil" [disabled]="disabledEditRules(value)"
                        class="p-button-rounded p-button-success p-mr-2" (click)="edit(value)"></button>
                </td>
                <td><p-button [disabled]=checkDisabedDownload(value) label="{{translations.lbl_show}}"
                        styleClass="p-button-link" (click)=openLink(value)></p-button>

                </td>
                <td *ngIf="this.showInternatColumns">
                    <button type="button" pButton pRipple icon="pi pi-check" (click)="onClickApprove(value)"
                        [disabled]="value.status=='A' || value.link==null"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{lstItemsTrak ? lstItemsTrak.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="itemDialog" [style]="{width: '750px'}" header="Ingrese valores" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">

            <div class="p-field">
                <label for="seqDt2">{{translations.lbl_id}} sequencia: *</label>
                <small class="p-error" *ngIf="!seqDt2">{{translations.lbl_id}} requerida.</small>
                <p-inputNumber id="seqDt2" [(ngModel)]="seqDt2" mode="decimal" [max]="999"></p-inputNumber>

                <label for="descrip">{{translations.lbl_name}}: *</label>
                <small class="p-error" *ngIf="!descrip">{{translations.lbl_name}} requerido.</small>
                <input type="text" pInputText id="descrip" [(ngModel)]="descrip" required autofocus maxlength="60" />

                <label for="link">{{translations.lbl_link}}: *</label>
                <small class="p-error" *ngIf="!link">{{translations.lbl_link}} requerido.</small>
                <input type="text" pInputText id="link" [(ngModel)]="link" required autofocus maxlength="500" />

            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-times"
                class="p-button-danger p-button-text" (click)="hideDialog()"></button>
            <button pButton pRipple label="{{translations.lbl_delete_record}}" icon="pi pi-times"
                class="p-button-delete p-button-text" (click)="removeSelected()"></button>
            <button pButton pRipple label="{{translations.lbl_save}}" icon="pi pi-check"
                class="p-button-success p-button-text" (click)="createUpdateTrack()"></button>
        </ng-template>
    </p-dialog>


</div>